export default "__VITE_ASSET__DSLoYzWL__"